<div class="row">
  <div class="col-3">
    <h2>jbDnD - Example 6</h2>
  </div>
  <div class="col-9 text-right">
    <jb-btn jbText="jbDnD" (jbClick)="router.navigate(['/jbDnD'])"></jb-btn>
    <jb-btn jbText="Ex.1" (jbClick)="router.navigate(['/jbDnD/example1'])"></jb-btn>
    <jb-btn jbText="Ex.2" (jbClick)="router.navigate(['/jbDnD/example2'])"></jb-btn>
    <jb-btn jbText="Ex.3" (jbClick)="router.navigate(['/jbDnD/example3'])"></jb-btn>
    <jb-btn jbText="Ex.4" (jbClick)="router.navigate(['/jbDnD/example4'])"></jb-btn>
    <jb-btn jbText="Ex.5" (jbClick)="router.navigate(['/jbDnD/example5'])"></jb-btn>
    <jb-btn jbText="Ex.6" (jbClick)="router.navigate(['/jbDnD/example6'])" jbDisabled="true"></jb-btn>
  </div>
</div>
<hr/>

<h4>Multiple Dragging Groups</h4>
<p>Using 2 different groups of drag and drop with [jbDragGroup].
<br>Elements on the left (group 1) cannot interact with elements on the right (group 2)</p>

<div class="row">
  <div class="col-3 padL50">
    <div class="board">
      <h4 class="padB30">Group 1</h4>
      <div jbDragGroup="group-1" [jbDraggable]="obj1">{{obj1.name}}</div>
      <div jbDragGroup="group-1" [jbDraggable]="obj2">{{obj2.name}}</div>
    </div>
  </div>
  <div class="col-3 padR50">
    <div class="board">
      <div jbDragGroup="group-1"
           jbDropContainer (jbDrop)="lastOp=$event.jbDraggable.name + ' dropped'; growl.success(lastOp)">
        <div class="text-center">
          <h6>Drop container 1</h6>
          <p>Only elements from group 1 are allowed here</p>
        </div>
      </div>
    </div>
  </div>


  <div class="col-3 padL50">
    <div class="board">
      <div jbDropContainer jbDragGroup="group-2"
           (jbDrop)="lastOp=$event.jbDraggable.name + ' dropped'; growl.success(lastOp)">
        <div class="text-center">
          <h6>Drop container 2</h6>
          <p>Only elements from group 2 are allowed here</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-3 padR50">
    <div class="board">
      <h4 class="padB30">Group 2</h4>
      <div jbDragGroup="group-2" [jbDraggable]="obj3">{{obj3.name}}</div>
      <div jbDragGroup="group-2" [jbDraggable]="obj4">{{obj4.name}}</div>
    </div>
  </div>
</div>
<div>Last Operation: <span class="last-op">{{lastOp}}</span></div>
<div>activeContainer = <span class="demo-active-container-id">{{jbDnD.activeContainer?.id}}</span></div>

<div class="row">
  <div class="col-12"><hr></div>

  <div class="col-8">
    <h5>View:</h5>
    <div class="code-box pad15">
      <pre>{{viewCode}}</pre>
    </div>
  </div>

  <div class="col-4">
    <h5>Scss:</h5>
    <div class="code-box pad15">
      <pre>{{scssCode}}</pre>
    </div>
  </div>

  <!--<div class="col-6">-->
  <!--  <h5>Ctrl:</h5>-->
  <!--  <div class="code-box pad15">-->
  <!--    <pre>{{ctrlCode}}</pre>-->
  <!--  </div>-->
  <!--</div>-->

</div>
